

import {createSlice} from '@reduxjs/toolkit';

import type {DataSectionInitialState, DataSectionSlice} from './typedef';
import type {Draft, PayloadAction} from '@reduxjs/toolkit';


export const getDataSectionSlice = <Data, GetActionRequest, SaveActionRequest, SaveActionReturnType = void>({
    name,
    initialData,

    getActionRequest,
    getActionSuccess,
    getActionFailure,

    saveActionRequest,
    saveActionSuccess,
    saveActionFailure,

    getDefaultDataActionRequest,
    getDefaultDataActionSuccess,
    getDefaultDataActionFailure,
}: DataSectionSlice<Data, GetActionRequest, SaveActionRequest, SaveActionReturnType>) => createSlice({
    name,
    initialState: {
        isLoading: false,
        isDefaultDataLoading: false,
        isBusy: false,
        loadingError: null,
        initialData,
        data: initialData,
    } as DataSectionInitialState<Data>,
    reducers: {
        clearData: state => {
            state.isLoading = false;
            state.isBusy = false;
            state.loadingError = null;
            state.initialData = initialData as Draft<Data>;
            state.data = initialData as Draft<Data>;
        },
        updateData: (state, action: PayloadAction<Data>) => {
            state.data = action.payload as Draft<Data>;
        },
        discardChanges: state => {
            state.data = state.initialData;
        },
        resetData: state => {
            state.data = state.defaultData;
        },
    },
    extraReducers: builder => {
        if (getActionRequest && getActionSuccess && getActionFailure) {
            builder
                .addCase(getActionRequest, state => {
                    state.isLoading = true;
                    state.loadingError = null;
                })
                .addCase(getActionSuccess, (state, action) => {
                    state.data = action.payload.data as Draft<Data>;
                    state.initialData = action.payload.data as Draft<Data>;
                    state.isLoading = false;
                })
                .addCase(getActionFailure, (state, action) => {
                    state.loadingError = action.payload.data;
                    state.isLoading = false;
                });
        }

        if (saveActionRequest && saveActionSuccess && saveActionFailure) {
            builder
                .addCase(saveActionRequest, state => {
                    state.isBusy = true;
                })
                .addCase(saveActionSuccess, state => {
                    state.initialData = state.data;
                    state.isBusy = false;
                })
                .addCase(saveActionFailure, state => {
                    state.isBusy = false;
                });
        }

        if (getDefaultDataActionRequest && getDefaultDataActionSuccess && getDefaultDataActionFailure) {
            builder
                .addCase(getDefaultDataActionRequest, state => {
                    state.isDefaultDataLoading = true;
                    state.defaultDataLoadingError = null;
                })
                .addCase(getDefaultDataActionSuccess, (state, action) => {
                    state.defaultData = action.payload.data as Draft<Data>;
                    state.isDefaultDataLoading = false;
                })
                .addCase(getDefaultDataActionFailure, (state, action) => {
                    state.defaultDataLoadingError = action.payload.data;
                    state.isDefaultDataLoading = false;
                });
        }
    },
});
